<template>
  <div>
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header">
      <div class="d-flex">
        <img
          class="back-to-list-apps"
          src="@/assets/icon/arrow-left.svg"
          @click="$router.push('/administrator/unit')"
        >
        <h3 class="label-header-form-ui ellipsis">
          {{ division_detail ? division_detail.name : '' }}
        </h3>
        <!-- <b-col>
            <i
              id="configPopover"
              class="fa fa-ellipsis-v fa-lg cursor-pointer pull-right m__t--10"/>
          </b-col> -->
      </div>
    </div>
    <div class="studio-page-content">
      <div>
        <j-division-form
          ref="divisionForm"
          mode="update"
          @data="getData"/>
      </div>
      <br>
      <div class="flex-column align-items-end">
        <b-button
          class="btn blue m__r--5"
          @click="saveUpdateDivision">
          Update
        </b-button>
        <b-button
          class="btn red"
          @click="deletedDivision">
          Delete
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import jDivisionForm from '@/views/division/jDivisionForm';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    jDivisionForm,
  },
  data() {
    return {
      division_data: null,
      title: {
        main_title: 'UPDATE DIVISION',
      },
    };
  },
  computed: {
    ...mapState('jStoreDivisionFlow', ['division_flow_data', 'division_detail']),
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),

    generateData() {
      const genData = {
        id: this.division_data.id,
        name: this.division_data.name ? this.division_data.name : '',
        code: this.division_data.code ? this.division_data.code : '',
        head_organigram_id: this.division_data.head_of_division ?
          this.division_data.head_of_division.id : 0,
        root_division_id: 0,
        description: this.division_data.description ? this.division_data.description : '',
      };
      return genData;
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions('jStoreDivisionFlow', ['updateDivision', 'deleteDivision', 'createFlowDivisionInUpdate', 'updateFlowDivisionInUpdate', 'deleteFlowDivisionInUpdate']),

    getData(data) {
      this.division_data = data;
    },
    saveUpdateDivision() {
      this.$refs.divisionForm.save();
      if (this.division_data !== null) {
        this.updateDivision(this.generateData);
        if (this.division_flow_data !== null) {
          if (this.division_flow_data.flow.id === 0) {
            // this.createFlowDivisionInUpdate(this.division_flow_data);
          } else {
            // this.updateFlowDivisionInUpdate(this.division_flow_data);
          }
        }
      }
    },
    deletedDivision() {
      const text = 'You want to delete this data';

      this.$swal({
        title: 'Are you sure?',
        text,
        type: 'question',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          this.deleteDivision({ id: this.$route.params.id });
          this.onClickBack();
          // this.deleteFlowDivisionInUpdate({ division_id: this.$route.params.id });
        }
      });
    },

    onClickBack() {
      this.$router.push('/administrator/unit');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/division/jDivisionUpdate.vue